import React from 'react';

export const useRevealOnScrollPast = (
  targetRef: React.RefObject<Element>
): boolean => {
  const [hasScrolledPast, setHasScrolledPast] = React.useState(false);

  React.useEffect(() => {
    const target = targetRef.current;

    if (!target) {
      return undefined;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) {
          setHasScrolledPast(true);
        }
      },
      { threshold: 0 }
    );

    observer.observe(target);

    return () => observer.disconnect();
  }, [targetRef]);

  return hasScrolledPast;
};
